module.exports = "<iframe [src]=\"getSefeUrl()\" style=\"width: 100%; height: 90vh;\"></iframe>"